const passesTiming = (dte, timing) => {
  if (timing === 'advance') return dte >= 1;
  if (timing === 'dos') return dte === 0;
  return true;
};

export default function buildChartRows(series, { product, timing, mode }) {
  let maxDte = -Infinity;
  series.forEach((s) => s.daily.forEach((d) => {
    if (passesTiming(d.dte, timing)) maxDte = Math.max(maxDte, d.dte);
  }));
  if (maxDte === -Infinity) return [];

  const lowBound = timing === 'advance' ? 1 : 0;
  const dtes = [];
  for (let dte = maxDte; dte >= lowBound; dte -= 1) dtes.push(dte);

  return dtes.map((dte) => {
    const row = { dte };
    series.forEach((s) => {
      const buckets = s.daily.filter((d) => passesTiming(d.dte, timing));
      if (mode === 'cumulative') {
        row[s.series_key] = buckets
          .filter((d) => d.dte >= dte)
          .reduce((sum, d) => sum + (d[product] || 0), 0);
      } else {
        const hit = buckets.find((d) => d.dte === dte);
        row[s.series_key] = hit ? (hit[product] || 0) : 0;
      }
    });
    return row;
  });
}
